import { render, staticRenderFns } from "./FamilyActivityTasks.vue?vue&type=template&id=fa3aa24e&scoped=true&"
import script from "./FamilyActivityTasks.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3aa24e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
